// extracted by mini-css-extract-plugin
export var cardHeader = "_em-0";
export var reorderHandle = "_em-3";
export var titleArea = "_em-1";
export var titleAreaWithHandle = "_em-2";